import React, { useEffect, useState, useRef } from 'react';
import { Container, Complemento } from './styles7';

import WebFont from "webfontloader";
import LogoErpWorks from "~/assets/logos/Logo ErpWorks Proposta Azul.png";

function Pagina7({ data }) {
  let linhas = "";//string.match(/(\r\n|\n|\r)/gm);
  let quantidadeLinhas = linhas ? linhas.length : 0;
  let resto = 0;

  return (
    <>
      <Container>
        <div className="barra-sup"></div>
        <div className="barra-sup2"></div>
        <div className="barra-sup3"></div>
        <div className="barra-sup4"></div>
        <div className="header">
          <div class="text">
            <p class="titulo">Data Emissão</p>
            <p class="titulo-data">{(new Date().toLocaleString().substr(0, 10))}</p>
          </div>
        </div>
        <div className="body">
          <div className="mid">
            <img src={LogoErpWorks} alt="Logo Erpworks" />
          </div>
          <div className="bottom">
            <div class="text">
              <p class="titulo-contato">Contatos:</p>
              <p class="titulo">www.erpworks.com.br</p>
              <p class="titulo">55 11 5181 3095</p>
              <p class="titulo">atendimento@erpworks.com.br</p>
              <p class="titulo">Av. Mofarrej, 348 – CJ 1308 Vila Leopoldina - São Paulo/SP | CEP: 05311-000</p>
            </div>
          </div>
        </div>
      </Container >
    </>
  );
};

export default Pagina7;